import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import TimerIcon from '@mui/icons-material/Timer';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import MoodIcon from '@mui/icons-material/Mood';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonIcon from '@mui/icons-material/Person';
import StarIcon from '@mui/icons-material/Star';
import ForumIcon from '@mui/icons-material/Forum';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: 18, borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアの短期・長期比較のポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: 18, borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('short-term')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    短期ルームシェアの特徴・メリット・デメリット
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: 18, borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('long-term')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    長期ルームシェアの特徴・メリット・デメリット
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: 18, borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('which-is-better')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    どちらが向いている？タイプ別おすすめ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: 18, borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('experiences')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    体験談：リアルな声を紹介
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: 18, borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('tips')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    専門家からのアドバイス・まとめ
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入部分 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアの短期・長期比較のポイント
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    近年、多様なライフスタイルに合わせて「ルームシェア」の形も進化しています。転職や留学、ワーケーション、都市部での暮らしの変化…。それぞれの目的に合わせて「短期」と「長期」どちらのルームシェアが自分に合っているのか、迷う方も多いのではないでしょうか。
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    本記事では、短期・長期それぞれの特徴やメリット・デメリット、向いている人のタイプ、実際の体験談まで詳しく解説します。自分にとって最適な選択肢を見つけるためのヒントにしてください。
                </Typography>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/share-living_roomshare-tanki-choki-hikaku-guide.jpg"
                        alt="明るい共有リビングで多国籍なルームメイト同士が朝食を囲み、和やかにコミュニケーションしている様子。白いウッド調の家具と観葉植物が温かみを演出し、リラックスした雰囲気が伝わる。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', marginBottom: 8 }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        共有スペースでのコミュニケーションは、ルームシェアの大きな魅力のひとつ
                    </Typography>
                </Box>
            </Box>
            <Divider sx={{ my: 2 }} />

            {/* 短期ルームシェア */}
            <Box id="short-term" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    短期ルームシェアの特徴・メリット・デメリット
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <Chip icon={<TimerIcon />} label="短期シェア" color="primary" variant="outlined" sx={{ mr: 1 }} />
                    <Chip label="1週間〜3ヶ月" variant="outlined" />
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    短期ルームシェアは、1週間〜3ヶ月程度の期間限定で部屋やスペースを共有する住まい方です。引越しや転職、短期の語学留学、トライアル的な居住体験など、目的はさまざま。柔軟性の高い暮らしを求める人に人気です。
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2, bgcolor: '#f7fafc', borderRadius: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ThumbUpAltIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6">メリット</Typography>
                            </Box>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="気軽に新しい環境・人間関係を体験できる"
                                        secondary="期間が短いので、失敗してもリスクが少ない"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="初期費用を抑えやすい"
                                        secondary="敷金・礼金不要や家具家電付き物件が多い"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="生活スタイルの変化に柔軟に対応"
                                        secondary="ライフステージや仕事の都合に合わせて住み替えしやすい"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2, bgcolor: '#fff8f6', borderRadius: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ThumbDownAltIcon color="error" sx={{ mr: 1 }} />
                                <Typography variant="h6">デメリット</Typography>
                            </Box>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="人間関係が浅くなりがち"
                                        secondary="ルームメイトと深い信頼関係を築きにくい"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="家賃単価がやや割高な傾向"
                                        secondary="短期契約のため、月額換算では割高になることも"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="生活リズムが安定しにくい"
                                        secondary="入れ替わりの多さや一時的な生活になる場合も"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/short-stay-room_roomshare-tanki-choki-hikaku-guide.jpg"
                        alt="清潔感のあるシンプルな個室にスーツケースを置き、短期滞在者が窓辺で外を眺めている様子。白を基調としたインテリアで、短期間でも快適に過ごせる雰囲気。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', marginBottom: 8 }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        短期滞在でも快適に過ごせる家具付き個室も増加中
                    </Typography>
                </Box>
            </Box>
            <Divider sx={{ my: 2 }} />

            {/* 長期ルームシェア */}
            <Box id="long-term" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    長期ルームシェアの特徴・メリット・デメリット
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <Chip icon={<EventAvailableIcon />} label="長期シェア" color="primary" variant="outlined" sx={{ mr: 1 }} />
                    <Chip label="6ヶ月以上〜年単位" variant="outlined" />
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    長期ルームシェアは、半年以上〜年単位で同じメンバーと住み続ける住まい方です。経済的なメリットや、深い人間関係を築ける点が特徴です。安定した生活基盤を求める人におすすめです。
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2, bgcolor: '#f7fafc', borderRadius: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ThumbUpAltIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6">メリット</Typography>
                            </Box>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="家賃・光熱費を大幅に節約できる"
                                        secondary="長期契約で割安なプランや交渉も可能"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="深い信頼関係・友人関係を築きやすい"
                                        secondary="継続的な生活を通じて本音で話せる仲間ができる"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="安定した生活リズム・環境が維持できる"
                                        secondary="共同生活のルールや役割分担が確立しやすい"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2, bgcolor: '#fff8f6', borderRadius: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ThumbDownAltIcon color="error" sx={{ mr: 1 }} />
                                <Typography variant="h6">デメリット</Typography>
                            </Box>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="人間関係のトラブルが長期化しやすい"
                                        secondary="合わない場合、ストレスが積み重なりやすい"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="プライベートの自由度が制限される場合も"
                                        secondary="共有ルールや生活リズムに縛られやすい"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="住み替えや退去がしにくい"
                                        secondary="契約期間や人間関係のしがらみが生じやすい"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/long-stay-living_roomshare-tanki-choki-hikaku-guide.jpg"
                        alt="温かみのあるリビングでルームメイト同士がソファに座り、リラックスした雰囲気で団らんしている。ナチュラルウッドとグリーンのインテリアが長期的な安心感と居心地の良さを演出。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', marginBottom: 8 }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        長期シェアなら、深い信頼関係や安心感が生まれやすい
                    </Typography>
                </Box>
            </Box>
            <Divider sx={{ my: 2 }} />

            {/* どちらが向いているか */}
            <Box id="which-is-better" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    どちらが向いている？タイプ別おすすめ
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <PersonIcon color="primary" sx={{ mr: 1 }} />
                                    <Typography variant="h6">短期シェア向きの人</Typography>
                                </Box>
                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StarIcon color="secondary" />
                                        </ListItemIcon>
                                        <ListItemText primary="新しい環境や人と出会うことにワクワクする" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StarIcon color="secondary" />
                                        </ListItemIcon>
                                        <ListItemText primary="予定やライフスタイルの変化が多い" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StarIcon color="secondary" />
                                        </ListItemIcon>
                                        <ListItemText primary="気軽に住み替えや体験を重視したい" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StarIcon color="secondary" />
                                        </ListItemIcon>
                                        <ListItemText primary="ワーケーションや短期プロジェクトなどに利用" />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ maxWidth: 345 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <PersonIcon color="primary" sx={{ mr: 1 }} />
                                    <Typography variant="h6">長期シェア向きの人</Typography>
                                </Box>
                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StarIcon color="secondary" />
                                        </ListItemIcon>
                                        <ListItemText primary="人間関係をじっくり深めたい" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StarIcon color="secondary" />
                                        </ListItemIcon>
                                        <ListItemText primary="家賃や生活費をしっかり抑えたい" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StarIcon color="secondary" />
                                        </ListItemIcon>
                                        <ListItemText primary="安定した環境で生活リズムを整えたい" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StarIcon color="secondary" />
                                        </ListItemIcon>
                                        <ListItemText primary="同じ仲間と共に成長したい" />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                        「どちらが得か」は一概には言えませんが、自分の目的や性格、ライフステージに合わせて選ぶのが成功のコツです。
                    </Typography>
                </Box>
            </Box>
            <Divider sx={{ my: 2 }} />

            {/* 体験談 */}
            <Box id="experiences" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    体験談：リアルな声を紹介
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2, bgcolor: '#f5fafd' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ForumIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" fontWeight="bold">短期シェア体験（20代・女性）</Typography>
                            </Box>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                「転職活動中に2ヶ月だけ知人とルームシェア。家具家電付きで初期費用も抑えられ、深い話もできて刺激になりました。期間が決まっていたので気楽に過ごせたのも良かったです。」
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2, bgcolor: '#f5fafd' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ForumIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" fontWeight="bold">長期シェア体験（30代・男性）</Typography>
                            </Box>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                「上京して5年以上、同じ仲間とルームシェア。家賃も抑えられるし、困った時に助け合える関係ができて心強いです。最初はルール作りが大変でしたが、今では家族のような安心感があります。」
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/share-experience_roomshare-tanki-choki-hikaku-guide.jpg"
                        alt="夜の共有キッチンで複数のルームメイトが一緒に料理や片付けをしながら談笑している様子。温かみのある照明とカジュアルな雰囲気が、共同生活の楽しさとリアルな一体感を伝えている。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', marginBottom: 8 }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        共同作業やイベントも、シェア生活の大切な思い出に
                    </Typography>
                </Box>
            </Box>
            <Divider sx={{ my: 2 }} />

            {/* アドバイス・まとめ */}
            <Box id="tips" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    専門家からのアドバイス・まとめ
                </Typography>
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2, bgcolor: '#f7fafc', mb: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        ルームシェアで失敗しないためのチェックポイント
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary="目的を明確にする" secondary="なぜシェアするのかを自分自身で整理しましょう" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary="契約内容・期間をしっかり確認" secondary="退去ルールや費用、共有部分の使い方も確認" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary="コミュニケーションを大切に" secondary="定期的な話し合いでトラブルを防ぐ" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary="自分に合ったスタイルを選ぶ" secondary="無理に合わせず、合わない場合は切り替える勇気も大切" />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    短期・長期、どちらも魅力と課題があります。大切なのは「自分に合った選択」をすること。まずは短期から始めてみて、気に入れば長期に切り替えるのもおすすめです。無理をせず、住まい選びを楽しんでください！
                </Typography>
                <Box sx={{ mt: 3 }}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                        ルームシェアの「短期・長期」どちらにしようか悩んだときは、この記事を参考に、ぜひ自分に最適な住まい方を見つけてください。
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-tanki-choki-hikaku-guide',
    slug: 'roomshare-tanki-choki-hikaku-guide',
    title: 'ルームシェアの「短期・長期」どちらが得？比較ガイド',
    excerpt: '短期シェアのメリット・デメリット 長期シェアのメリット・デメリット 向いている人の特徴 体験談',
    coverImage: '/images/blog/cover-roomshare-tanki-choki_roomshare-tanki-choki-hikaku-guide.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。快適なインテリアと温かな雰囲気が調和し、シェア生活の魅力が伝わる。',
    publishedAt: '2024-06-27T00:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '住まい選び', '暮らし'],
    tags: ['短期ルームシェア', '長期ルームシェア', '比較ガイド'],
    author: {
        name: '佐藤 みちる',
        avatar: '/images/avatars/author-michiru.jpg',
        bio: 'ルームシェア・賃貸住宅の実務経験を持つ住宅コンサルタント。最新の住まいトレンドやコミュニティ型ライフスタイルの情報発信を行っている。',
        profilePicture: '/images/avatars/author-michiru.jpg'
    },
    viewCount: 1350,
    contentComponent: PostContent
};

export default post;